import { createAction } from "@reduxjs/toolkit";
import { Room, TableItem } from "../types";
import { MyActiveTablesResponse } from "../../api/gameApi";

export const roomOpen = createAction<{
  roomId?: string | number;
}>("room/open");
export const roomClose = createAction("room/close");
export const roomLoaded = createAction<Room>("room/loaded");
export const roomError = createAction<string>("room/error");

export const tablesSet = createAction<TableItem[]>("room/tables/set");
export const tablesAppend = createAction<TableItem[]>("room/tables/append");
export const tablesUpdateSeats = createAction<{ id: number; inc: boolean }>(
  "room/tables/updateSeats"
);
export const tablesRemove = createAction<number>("room/tables/remove");

// export const fetchMyActiveTablesRequest = createAction(
//   "room/fetchMyActiveTables/request"
// );
// export const fetchMyActiveTablesSuccess = createAction<MyActiveTablesResponse>(
//   "room/fetchMyActiveTables/success"
// );
// export const fetchMyActiveTablesFailure = createAction<string>(
//   "room/fetchMyActiveTables/failure"
// );

// export const fetchRoomBySlugRequest = createAction<string>(
//   "room/fetchRoomBySlug/request"
// );
// export const fetchRoomBySlugSuccess = createAction<any>(
//   "room/fetchRoomBySlug/success"
// );
// export const fetchRoomBySlugFailure = createAction<string>(
//   "room/fetchRoomBySlug/failure"
// );

// export const fetchTableBySlugRequest = createAction<{
//   roomSlug: string;
//   tableName: string;
// }>("room/fetchTableBySlug/request");
// export const fetchTableBySlugSuccess = createAction<any>(
//   "room/fetchTableBySlug/success"
// );
// export const fetchTableBySlugFailure = createAction<string>(
//   "room/fetchTableBySlug/failure"
// );

// export const fetchSngRegisterCountRequest = createAction(
//   "room/fetchSngRegisterCount/request"
// );
// export const fetchSngRegisterCountSuccess = createAction<number>(
//   "room/fetchSngRegisterCount/success"
// );
// export const fetchSngRegisterCountFailure = createAction<string>(
//   "room/fetchSngRegisterCount/failure"
// );

// export const clearError = createAction("room/clearError");
